import { render, staticRenderFns } from "./CardTool.vue?vue&type=template&id=07584f2f&scoped=true&"
import script from "./CardTool.vue?vue&type=script&lang=js&"
export * from "./CardTool.vue?vue&type=script&lang=js&"
import style0 from "./CardTool.vue?vue&type=style&index=0&id=07584f2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07584f2f",
  null
  
)

export default component.exports